import { render, staticRenderFns } from "./DepositAndWithdrawal.vue?vue&type=template&id=623695ae&scoped=true"
import script from "./DepositAndWithdrawal.vue?vue&type=script&scoped=true&lang=js"
export * from "./DepositAndWithdrawal.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./DepositAndWithdrawal.vue?vue&type=style&index=0&id=623695ae&prod&scoped=true&lang=css"
import style1 from "./DepositAndWithdrawal.vue?vue&type=style&index=1&id=623695ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623695ae",
  null
  
)

export default component.exports